import { USER_BONUS_TABLE_PT_BR } from "#components/tables/reports/user-bonus-table/translations/user-bonus-table-pt-br";
import { TRANSACTIONS_REPORT_PT_BR } from "#components/transactions-report/translations";
import { BARS_AND_SECTORS_PT_BR } from "#pages/place/bars/translations/bars-and-sectors-pt-br";
import { BONUS_CATEGORIES_PT_BR } from "#pages/place/bonus-categories/translations";
import { EXTRACT_PT_BR } from "#pages/place/extract-new/translations/extract-pt-br";
import { BONUS_REPORT_FOR_PLACE_PT_BR } from "#pages/place/financial-reports/bonus-report-for-place/translations";
import { BONUS_REPORT_PT_BR } from "#pages/place/financial-reports/bonus-report/translations";
import { USED_BONUS_REPORT_PT_BR } from "#pages/place/financial-reports/bonus-report/used-bonus-report/translations";
import { precharge_PT_BR } from "#pages/place/precharge/pages/translations";
import { IMPORT_PT_BR } from "#pages/place/purchase-invoice/import-invoice/translations/import-pt-br";
import { PURCHASE_INVOICE_PT_BR } from "#pages/place/purchase-invoice/translations/purchase-invoice-pt-br";
import { CATERING_PT_BR } from "#pages/place/catering/translations/catering-pt-br";
import { audits } from "./audits";
import { barReports } from "./bar-reports";
import { businessIntelligence } from "./business-intelligence/";
import { coala } from "./coala";
import { contracts } from "./contracts";
import { delivery } from "./delivery";
import { discountCategory } from "./discount-category";
import { emissionErrors } from "./emission-errors";
import { emited } from "./emited";
import { entrance } from "./entrance";
import { entranceBilling } from "./entrance-billing/";
import { events } from "./events/";
import { extract } from "./extract";
import { financialReport } from "./financial-report/";
import { fiscalReport } from "./fiscal-report";
import { guestList } from "./guest-list/";
import { importXml } from "./import-xml";
import { reserveV2 } from "./reserve-v2";
import { inventoryControl } from "./inventory-control";
import { invoicesBackups } from "./invoices-backups";
import { invoicesIva } from "./invoices-iva";
import { invoicesNational } from "./invoices-national";
import { kardex } from "./kardex";
import { kds } from "./kds";
import { multivendor } from "./multivendor";
import { notEmitedProducts } from "./not-emited-products";
import { passwordCard } from "./password-card";
import { placeData } from "./place-data";
import { pos } from "./pos";
import { prechargeReports } from "./precharge-reports";
import { productMenu } from "./product-menu";
import { products } from "./products";
import { productArea } from "./products/product-area";
import { productDetail } from "./products/product-detail";
import { promotion } from "./promotion";
import { promotions } from "./promotions";
import { settings } from "./settings";
import { storage } from "./storage/";
import { tagGroups } from "./tag-groups";
import { whatsUp } from "./whats-up";
import { rechargeManagement } from "./recharge-management";
import { recharges } from "./recharges";
import { reserve } from "./reserve";
import { search } from "./search";
import { TRANSACTIONS_PT_BR } from "./transactions";

export const placePT = {
	placeTitle: "Locais",
	insights: {
		previewTitle: "INSIGHTS RECENTES",
		viewAll: "Ver todos os insights",
		newToday: "novos hoje",
		pageTitle: "Insights e Sugestões",
		pageSubtitle: "Recomendações geradas automaticamente para sua operação.",
		backToPlaces: "Voltar para Locais",
		all: "Todos",
		noInsights: "Nenhum insight disponível no momento.",
		insightCount: "insight",
		insightCountPlural: "insights",
		benchmark: "Benchmark",
	},
	placeWithoutEvent: "Locais sem evento há mais de um mês",
	placeWithOpenEvent: "Locais com evento em curso",
	placeWithoutEventInProgress: "Locais sem evento em curso",
	searchPlaceInputPlaceholder: "Buscar local",
	timezone: "Timezone",
	currency: "Moeda",
	subtitle: "Legenda",
	alphabeticalOrder: "Ordem alfabética",
	lastEventOrder: "Último evento criado",
	initialDefaultDateOrder: "Filtro padrão de datas",
	financialFile: {
		title: "Arquivo financeiro",
		description: "Acompanhe suas solicitações de equipamentos e assinaturas.",
		titleDescription: "Descrição",
		downloadButton: "Download",
		table: {
			columns: {
				name: "Nome",
				contractId: "ID do contrato",
				period: "Período",
			},
		},
		eventType: {
			festival: "Festival",
			fixedVenue: "Casa Fixa",
			event: "Evento",
			sports: "Esportivo",
			fairs: "Feiras",
			beachClub: "Beach Club",
			retail: "Varejo",
			bar: "Bar",
			others: "Outros",
			hotel: "Hotel",
			restaurant: "Restaurante",
			school: "Escola",
			arena: "Arena (Estádio)",
			hospitality: "Hospitality",
			nightclub: "Balada",
			barRestaurant: "Bar & Restaurante",
			beachTennisCourt: "Quadra de Beach Tennis",
			carnival: "Carnaval",
			juneParty: "Festa Junina",
			musicFestival: "Festival de Música",
			show: "Show",
			newYearsEve: "Réveillon",
			eventVenue: "Casa de evento",
			musicShow: "Show de música",
			sportsEvent: "Evento esportivo",
			gastronomicEvent: "Evento Gastronômico",
			religiousEvent: "Evento religioso",
			schoolEvent: "Evento escolar",
			seasonalHouse: "Casa de Temporada",
		},
		eventModel: {
			monthly: "Mensal",
			weekly: "Semanal",
			oneTime: "Avulso",
		},
		invoiceType: {
			daily: "Diário",
			weekly: "Semanal",
			monthly: "Mensal",
			atTermination: "Ao Término",
			perSession: "Por Sessão",
		},
		financialClosingTitle: "Fechamento Financeiro",
		zigDataSection: "Dados - Zig",
		currency: "Moeda",
		document: "Documento",
		name: "Nome",
		address: "Endereço",
		eventDataSection: "Dados - Evento",
		period: "Período",
		notInformed: "Não informado",
		type: "Tipo",
		zigExecutive: "Executivo Zig",
		model: "Modelo",
		billing: "Faturamento",
		automaticRepayment: "Repasse Automático",
		yes: "Sim",
		no: "Não",
		placeId: "PlaceId",
		organizationId: "OrganizationId",
		clientDataSection: "Dados - Cliente",
		client: "Cliente",
		contract: "Contrato",
		contractValidity: "Vigência do Contrato",
		eventBillingHeader: "Faturamento - Evento",
		value: "Valor",
		total: "Total",
		totalBilling: "Faturamento Total",
		zigBillingHeader: "Faturamento - Zig",
		item: "Item",
		base: "Base",
		taxRate: "Taxa (%)",
		zigInvoiceSummary: "Resumo Fatura Zig",
		finalResultHeader: "Resultado Final",
		integratedAcquiringBalance: "Saldo gerado por Adquirência Integrada",
		nonIntegratedAcquiringBalance: "Saldo gerado por Adquirência Não Integrada",
		zigInvoice: "Fatura Zig",
		balanceToTransfer: "Saldo a Repassar",
		finalBalanceToTransfer: "Saldo Final a Repassar",
		technicalAnalysisHeader: "Análise Técnica",
		previousValue: "Valor Anterior",
		newValue: "Novo Valor",
		issuance: "Emissão",
		date: "Data",
		version: "Versão",
		meta: "Meta",
		other: "Outros",
		eventEntries: "Lançamentos - Evento",
		totalBalance: "Total Final",
		tpvOthers: "TPV Outros",
		integratedAcquiring: "Adquirência Integrada",
		nonIntegratedAcquiring: "Adquirência Não Integrada",
		zigBilling: "Faturamento ZIG",
		balanceMovement: "Movimentação de saldo",
		to: "a",
	},
	subtitles: {
		onGoingEvent: "Evento em curso",
		recentEvent: "Evento recente",
		longTimeWithoutEvent: "Longo tempo sem evento",
		waitingForApproval: "Aguardando Aprovação",
		noEvent: "Sem evento",
	},
	placelinks: {
		post: "Pós",
		pre: "Pré",
		noEvents: "Sem eventos",
		none: "Nenhum evento",
		openEvent: "Evento aberto",
	},
	placeTabs: {
		products: "Produtos",
		combos: "Combos",
		supplies: "Insumos",
		bars: "Bares",
		beer: "Chopeira",
		gng: "Grab and Go",
		cmv: "Eng. de cardápio",
		config: "Configurações de cardápios",
		catering: "Catering",
	},
	events,
	products,
	productMenu,
	businessIntelligence,
	entranceBilling,
	tagGroups,
	reserve,
	reserveV2,
	storage,
	financialReport,
	guestList,
	entrance,
	pos,
	promotions,
	whatsUp,
	audits,
	settings,
	precharge: precharge_PT_BR,
	barReports,
	extract,
	passwordCard,
	notEmitedProducts,
	promotion,
	search,
	transactions: TRANSACTIONS_PT_BR,
	invoicesIva,
	invoicesNational,
	invoicesBackups,
	kardex,
	multivendor,
	coala,
	discountCategory,
	emissionErrors,
	emited,
	fiscalReport,
	importXml,
	productDetail,
	productArea,
	inventoryControl,
	prechargeReports,
	contracts,
	rechargeManagement,
	recharges,
	transactionsReport: TRANSACTIONS_REPORT_PT_BR,
	bonusCategories: BONUS_CATEGORIES_PT_BR,
	kds,
	purchaseInvoiceV2: PURCHASE_INVOICE_PT_BR,
	import: IMPORT_PT_BR,
	delivery,
	extractNew: EXTRACT_PT_BR,
	usedBonusReport: USED_BONUS_REPORT_PT_BR,
	userBonusTable: USER_BONUS_TABLE_PT_BR,
	bonusReport: BONUS_REPORT_PT_BR,
	bonusReportForPlace: BONUS_REPORT_FOR_PLACE_PT_BR,
	placeData,
	managerOrders: {
		orderDetailModal: {
			title: "Detalhes do pedido",
			orderNumber: "Pedido n° #{{orderNumber}}",
			nameLabel: "Nome",
			dateLabel: "Dia e horário",
			dateValue: "{{date}} às {{hour}}",
			originLabel: "Origem do pedido",
			refuseOrder: "Recusar pedido",
			acceptOrder: "Aceitar pedido",
			cancelOrder: "Cancelar pedido",
			readyOrder: "Pedido pronto",
			dispatchOrder: "Despachar pedido",
			concludeOrder: "Concluir pedido",
			itemsTitle: "Itens do pedido",
			itemsColumnName: "Item",
			itemsColumnUnitPrice: "Preço unitário",
			itemsColumnTotalPrice: "Preço total",
			totalLabel: "Total",
			deliveryFeeLabel: "Taxa de entrega",
			serviceFeeLabel: "Taxa de serviço",
			additionalFeeLabel: "Taxa de pedido mínimo",
			tipLabel: "Gorjeta",
			discountLabel: "Desconto",
			discountStoreLabel: "Desconto da loja",
			discountMarketplaceLabel: "Desconto do iFood",
			discountKeetaLabel: "Desconto Keeta",
			discountFood99Label: "Desconto 99Food",
			obsLabel: "Observação",
			obsTitle: "Observações Adicionais",
			deliveryDetailsTitle: "Detalhes de entrega",
			paymentMethodLabel: "Método de pagamento",
			paymentMethodCardValue: "Cartão",
			changeBackLabel: "Troco para",
			deliveryTypeLabel: "Tipo de entrega",
			deliveryByStoreValue: "Entrega da loja",
			deliveryByPlatformValue: "Entrega da plataforma",
			locatorLabel: "Localizador",
			needCutleryLabel: "Talheres",
			needCutleryYes: "Cliente solicitou talheres",
			addressLabel: "Endereço",
			contactLabel: "Contato",
			cpfLabel: "CPF",
			phoneLabel: "Telefone",
			unknownLabel: "Documento desconhecido",
			unknown: "Não informado",
			printOrder: "Imprimir pedido",
			toastAcceptTitle: "Pedido aceito",
			toastAcceptDescription:
				'O <bold>#{{orderNumber}}</bold> foi aceito e você pode conferir na aba de pedidos "<bold>Aceitos</bold>"',
			toastReadyTitle: "Pedido pronto",
			toastReadyDescription:
				'O <bold>#{{orderNumber}}</bold> foi marcado como pronto e você pode conferir na aba de pedidos "<bold>Prontos</bold>"',
			toastDispatchTitle: "Pedido despachado",
			toastDispatchDescription:
				'O <bold>#{{orderNumber}}</bold> foi despachado e você pode conferir na aba de pedidos "<bold>Em entrega</bold>"',
			toastConcludeTitle: "Pedido concluído",
			toastConcludeDescription:
				'O <bold>#{{orderNumber}}</bold> foi concluído e você pode conferir na aba de pedidos "<bold>Concluídos</bold>"',
			toastCancelTitle: "Pedido cancelado",
			toastCancelDescription:
				'O <bold>#{{orderNumber}}</bold> foi cancelado e você pode conferir na aba de pedidos "<bold>Cancelados</bold>"',
			statusMessagePlaced: "Aceite ou recuse o pedido para continuar.",
			statusMessageConfirmed: "Prepare o pedido e marque como pronto quando finalizar.",
			statusMessageReady: "Despache quando o motoboy responsável coletar o pedido.",
			statusMessageReadyDineIn: "Conclua o pedido quando o cliente retirar no local.",
			statusMessageDispatched: "Conclua o pedido quando a entrega for finalizada.",
		},
		refuseOrderConfirmation: {
			title: "Recusar pedido",
			message: "Tem certeza que deseja recusar este pedido?",
			confirmButton: "Recusar",
			secondaryMessage: "Esta ação não pode ser desfeita.",
		},
	},
	barsAndSectors: BARS_AND_SECTORS_PT_BR,
	catering: CATERING_PT_BR,
};
